'use client'

import { Spinner } from '@/components/extension/spinner'
import { ProductFormatted } from '@/types/product'
import { AmazonProductItemInfo } from './amazon-product-item-info'
import { AmazonProductItemThumbnail } from './amazon-product-item-thumbnail'
import {
  AmazonProductCardProvider,
  useAmazonProductCardContext,
} from './context/amazon-product-card-context'

type Props = {
  product: ProductFormatted
  gaTrackingValue?: string
  gaTrackingLabel?: string
  theme?: 'light' | 'dark'
  isSoldProduct?: boolean
}

const AmazonProductCardContent = ({
  gaTrackingValue,
  gaTrackingLabel,
  isSoldProduct,
}: {
  gaTrackingValue?: string
  gaTrackingLabel?: string
  isSoldProduct?: boolean
}) => {
  const { isPendingAddToCart } = useAmazonProductCardContext()

  return (
    <div className='relative w-full shrink-0 grow-0 rounded-xl border border-neutral-600'>
      {isPendingAddToCart ? (
        <div
          className='absolute inset-0 z-10 flex items-center justify-center bg-neutral-100/50'
          role='status'
          aria-label='Adding to cart'
        >
          <Spinner size='large' />
        </div>
      ) : null}
      <figure className='space-y-3' role='group' aria-label='Product card'>
        <AmazonProductItemThumbnail
          gaTrackingValue={gaTrackingValue}
          gaTrackingLabel={gaTrackingLabel}
        />
        <AmazonProductItemInfo
          gaTrackingValue={gaTrackingValue}
          gaTrackingLabel={gaTrackingLabel}
          isSoldProduct={isSoldProduct}
        />
      </figure>
    </div>
  )
}

export const AmazonProductCard = ({
  product,
  gaTrackingValue,
  gaTrackingLabel,
  theme,
  isSoldProduct,
}: Props) => {
  return (
    <AmazonProductCardProvider product={product} theme={theme}>
      <AmazonProductCardContent
        gaTrackingValue={gaTrackingValue}
        gaTrackingLabel={gaTrackingLabel}
        isSoldProduct={isSoldProduct}
      />
    </AmazonProductCardProvider>
  )
}
